<div class="w-full h-full min-h-0 overflow-auto">
    <p-card class="w-full h-full flex flex-col">
        <div class="flex-1 min-h-0 overflow-auto">
            <p-treeTable
                #dt
                (onLazyLoad)="onLazyLoad($event)"
                (onNodeExpand)="onNodeExpand($event)"
                [filterDelay]="0"
                [globalFilterFields]="[
                    'protocolo',
                    'tipoObra',
                    'autor',
                    'tipoRepresentacao',
                    'data',
                    'situacao'
                  ]"
                [lazy]="true"
                [loading]="false"
                [paginator]="true"
                [rowHover]="true"
                [rowsPerPageOptions]="[10, 25, 50]"
                [rows]="10"
                [showCurrentPageReport]="true"
                [showLoader]="false"
                [totalRecords]="totalRecords"
                [value]="dataTree"
                currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} entradas"
                dataKey="key"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th scope="col" style="min-width: 14rem" ttSortableColumn="demanda.protocolo">
                            <div class="flex justify-between items-center w-full">
                                Protocolo
                                <p-treeTableSortIcon field="demanda.protocolo"/>
                            </div>
                        </th>
                        <th scope="col" style="min-width: 14rem" ttSortableColumn="tipoObra">
                            <div class="flex justify-between items-center w-full">
                                Tipo de Obra
                                <p-treeTableSortIcon field="tipoObra"/>
                            </div>
                        </th>
                        <th scope="col" style="min-width: 14rem" ttSortableColumn="demanda.usuarioCriacao.nome">
                            <div class="flex justify-between items-center w-full">
                                Autor
                                <p-treeTableSortIcon field="demanda.usuarioCriacao.nome"/>
                            </div>
                        </th>
                        <th scope="col" style="min-width: 10rem" ttSortableColumn="tipoRepresentacao">
                            <div class="flex justify-between items-center w-full">
                                Representação
                                <p-treeTableSortIcon field="tipoRepresentacao"/>
                            </div>
                        </th>
                        <th scope="col" style="min-width: 10rem" ttSortableColumn="demanda.dataCriacao">
                            <div class="flex justify-between items-center w-full">
                                Data
                                <p-treeTableSortIcon field="demanda.dataCriacao"/>
                            </div>
                        </th>
                        <th scope="col" style="min-width: 10rem" ttSortableColumn="situacao">
                            <div class="flex justify-between items-center w-full">
                                Situação
                                <p-treeTableSortIcon field="situacao"/>
                            </div>
                        </th>
                        <th scope="col" alignFrozen="right" pFrozenColumn style="width: 6rem">
                            <div class="flex justify-center items-center">Ações</div>
                        </th>
                    </tr>

                    <tr>
                        <th scope="col">
                            <p-iconfield size="small">
                                <p-inputicon><i class="pi pi-search"></i></p-inputicon>
                                <input (input)="onFilterInput($event, 'protocolo')"
                                       [ngModel]="currentFilters['protocolo']"
                                       fluid
                                       maxlength="255" pInputText placeholder="Pesquise" size="small" type="text"/>
                                @if (currentFilters['protocolo']) {
                                    <p-inputicon
                                            (click)="clearFilter('protocolo')"
                                            (keydown.enter)="$event.preventDefault(); clearFilter('protocolo')"
                                            (keydown.space)="$event.preventDefault(); clearFilter('protocolo')"
                                            tabindex="0"
                                            class="pi pi-times cursor-pointer"
                                    />
                                }
                            </p-iconfield>
                        </th>

                        <th scope="col">
                            <p-iconfield size="small">
                                <p-inputicon><i class="pi pi-search"></i></p-inputicon>
                                <input (input)="onFilterInput($event, 'tipoObra')"
                                       [ngModel]="currentFilters['tipoObra']"
                                       fluid
                                       maxlength="255" pInputText placeholder="Pesquise" size="small" type="text"/>
                                @if (currentFilters['tipoObra']) {
                                    <p-inputicon
                                            (click)="clearFilter('tipoObra')"
                                            (keydown.enter)="$event.preventDefault(); clearFilter('tipoObra')"
                                            (keydown.space)="$event.preventDefault(); clearFilter('tipoObra')"
                                            tabindex="0"
                                            class="pi pi-times cursor-pointer"
                                    />
                                }
                            </p-iconfield>
                        </th>

                        <th scope="col">
                            <p-iconfield size="small">
                                <p-inputicon><i class="pi pi-search"></i></p-inputicon>
                                <input (input)="onFilterInput($event, 'autor')"
                                       [ngModel]="currentFilters['autor']"
                                       fluid
                                       maxlength="255" pInputText placeholder="Pesquise" size="small" type="text"/>
                                @if (currentFilters['autor']) {
                                    <p-inputicon
                                            (click)="clearFilter('autor')"
                                            (keydown.enter)="$event.preventDefault(); clearFilter('autor')"
                                            (keydown.space)="$event.preventDefault(); clearFilter('autor')"
                                            tabindex="0"
                                            class="pi pi-times cursor-pointer"
                                    />
                                }
                            </p-iconfield>
                        </th>

                        <th scope="col">
                            <p-iconfield size="small">
                                <p-inputicon><i class="pi pi-search"></i></p-inputicon>
                                <input (input)="onFilterInput($event, 'representacao')"
                                       [ngModel]="currentFilters['representacao']"
                                       fluid
                                       maxlength="255" pInputText placeholder="Pesquise" size="small" type="text"/>
                                @if (currentFilters['representacao']) {
                                    <p-inputicon
                                            (click)="clearFilter('representacao')"
                                            (keydown.enter)="$event.preventDefault(); clearFilter('representacao')"
                                            (keydown.space)="$event.preventDefault(); clearFilter('representacao')"
                                            tabindex="0"
                                            class="pi pi-times cursor-pointer"
                                    />
                                }
                            </p-iconfield>
                        </th>

                        <th scope="col">
                            <p-date-picker (onClear)="clearFilter('data')"
                                           (onSelect)="onFilterInput($event, 'data')"
                                           [(ngModel)]="currentFilters['data']" [iconDisplay]="'input'"
                                           [readonlyInput]="true"
                                           [showClear]="true" [showIcon]="true"
                                           appendTo="body"
                                           dateFormat="dd/mm/yy" fluid placeholder="Selecione"/>
                        </th>

                        <th scope="col">
                            <p-iconfield size="small">
                                <p-select
                                        (onChange)="onFilterInput($event.value, 'situacao')"
                                        (onClear)="clearFilter('situacao')"
                                        [(ngModel)]="currentFilters['situacao']"
                                        [filter]="true"
                                        [fluid]="true"
                                        [options]="situacaoOptions"
                                        [showClear]="true"
                                        appendTo="body"
                                        filterBy="label"
                                        optionLabel="label"
                                        optionValue="value"
                                        placeholder="Selecione"
                                ></p-select>
                            </p-iconfield>
                        </th>

                        <th scope="col" alignFrozen="right" pFrozenColumn></th>
                    </tr>

                </ng-template>

                <ng-template let-rowData="rowData" let-rowNode pTemplate="body">
                    <tr [ttRow]="rowNode">
                        <td>
                            @if (rowNode?.disabled === false) {
                                <span pTooltip="Reforços da Demanda">
                                    <p-treeTableToggler [rowNode]="rowNode"/>
                                  </span>
                            } @else {
                                <p-treeTableToggler [rowNode]="rowNode"/>
                            }

                            {{ rowData.protocolo }}
                        </td>


                        <td>{{ rowData.tipoObra }}</td>
                        <td>{{ rowData.autor }}</td>
                        <td>{{ rowData.tipoRepresentacao }}</td>
                        <td>{{ rowData.data | datePtbr }}</td>
                        <td>{{ rowData.situacao }}</td>
                        <td pFrozenColumn>
                            <div class="flex flex-col md:flex-row gap-2 items-center justify-center">
                                <p-button (click)="onClickVisualizar(rowData.id)"
                                    (keydown.enter)="$event.preventDefault(); onClickVisualizar(rowData.id)"
                                    (keydown.space)="$event.preventDefault(); onClickVisualizar(rowData.id)" ariaLabel="Visualizar"
                                          pTooltip="Visualizar"
                                          styleClass="btn-icon"
                                          tooltipPosition="left">
                                    <app-icon-eye/>
                                </p-button>
                                @if (!rowNode.parent) {
                                    <p-button (click)="onClickReforcar(rowData.id)"
                                        (keydown.enter)="$event.preventDefault(); onClickReforcar(rowData.id)"
                                        (keydown.space)="$event.preventDefault(); onClickReforcar(rowData.id)" ariaLabel="Reforçar Demanda"
                                              pTooltip="Reforçar Demanda"
                                              styleClass="btn-icon"
                                              tooltipPosition="left">
                                        <app-icon-location-add/>
                                    </p-button>
                                } @else {
                                    <p-button ariaLabel="Reforçar Demanda" disabled
                                              pTooltip="Não é possível reforçar novamente"
                                              styleClass="btn-icon" tooltipPosition="left">
                                        <app-icon-location-add color="#858796"/>
                                    </p-button>
                                }
                            </div>
                        </td>
                    </tr>
                    @if (rowNode.expanded && loadingLeafTable && rowNode.children?.length === 0) {
                        <tr>
                            <td colspan="7" style="padding: 0;">
                                <p-skeleton height="40px" width="100%"></p-skeleton>
                            </td>
                        </tr>
                    }
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    @if (loading) {
                        @for (i of [1, 2, 3]; track $index) {
                            <tr>
                                @for (column of [1, 2, 3, 4, 5, 6, 7]; track $index) {
                                    <td>
                                        <p-skeleton height="1.5rem" width="100%"></p-skeleton>
                                    </td>
                                }
                            </tr>
                        }
                    } @else {
                        <tr>
                            <td colspan="7">Nenhuma demanda encontrada.</td>
                        </tr>
                    }
                </ng-template>
            </p-treeTable>
        </div>
    </p-card>
</div>

@if (showReforcarDemandaDialog) {
    <app-visualizar-reforcar-demanda-dialog (refresh)="onReforcarDemandaSuccess()"
                                            [(visible)]="showReforcarDemandaDialog"
                                            [demandaId]="demandaSelecionadaId"
                                            [editMode]="true"
                                            [mode]="'reforcar'"></app-visualizar-reforcar-demanda-dialog>
}
@if (showVisualizarDemandaDialog) {
    <app-visualizar-reforcar-demanda-dialog [(visible)]="showVisualizarDemandaDialog"
                                            [demandaId]="demandaSelecionadaId"
                                            [editMode]="false"
                                            [mode]="'visualizar'"></app-visualizar-reforcar-demanda-dialog>
}
<p-toast/>
